import React, { FC, useEffect, useState } from 'react';
import { resendOtp } from '../../redux/AuthCRUD';
import * as auth from '../../redux/AuthRedux'
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

const ResendOTP: FC = () => {
  const [localIsResendButtonActive, setLocalIsResendButtonActive] = useState(false);
  const [localCountdown, setLocalCountdown] = useState(5);
  const [loading, setLoading] = useState(false)
  const [buttonUsed, setButtonUsed] = useState(false)
  const dispatch = useDispatch()

  const handleLocalResendClick = async () => {
    try {
      setLoading(true)
      resendOtp()
        .then(({ data }) => {
          setButtonUsed(true)
          setLocalCountdown(0)
          setLoading(false)
          if (data.status) {
            dispatch(auth.actions.otpResend(data.data))
          }
        })
        .catch(() => {
          setLoading(false)
        })
        .finally(() => {
        });
      console.log('Resend API Başarılı');
    } catch (error) {
      console.error('Resend API Hatası:', error);
    }
  };

  useEffect(() => {
    let countdownTimer: NodeJS.Timeout;

    if (localCountdown > 0) {
      countdownTimer = setInterval(() => {
        setLocalCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    } else {
      setLocalIsResendButtonActive(true);
    }

    return () => clearInterval(countdownTimer);
  }, [localCountdown, setLocalIsResendButtonActive, setLocalCountdown]);

  return (
    <>
      <div className="text-center fw-semibold fs-5">
        <span className="text-muted me-1">Kodu alamadınız mı ?</span>
        {
          !buttonUsed ?
            (!loading ?
              <Link to={'#'} className='link-primary fs-5 me-1' onClick={handleLocalResendClick}>Tekrar Gönder</Link>
              : (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  Bekleyin...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )
            )
            : <Link to={'#'} className='link-primary fs-5 me-1'>Bizimle İletişime Geç</Link>
        }
      </div>
    </>
  );
};

export default ResendOTP;
